import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IItemWishList } from 'src/app/shared/interfaces/custom-item-wish-list';
import { WishList } from 'src/app/utils/functions/wishList';

@Component({
  selector: 'app-custom-item-order-list',
  templateUrl: './custom-item-order-list.component.html'
})
export class CustomItemOrderListComponent {

  @Input() product: IItemWishList = new IItemWishList;
  @Output() listChanges = new EventEmitter<boolean>();
 

  deleteProductCar: boolean = false;

  constructor(
    private wishList: WishList,  ){

  }

  changeCant(eventData: any){
    this.wishList.updateItemWishList(this.product.product, eventData);
    this.listChanges.emit(true);
  }

  delete(){
    this.deleteProductCar = true;
  }

  closeModal(eventData: boolean) {
    this.deleteProductCar = eventData;
  }

  closeModalAndDelete(eventData: boolean) {
    this.deleteProductCar = eventData;
    this.wishList.deleteItem(this.product.product);
    this.listChanges.emit(true);
  }

  showPrice() {
    return this.product.product.isOnDiscount
      ? this.product.product.priceDiscount
      : this.product.product.price
  }
}
